"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const WidgetArea_1 = require("./impl/WidgetArea");
class SideBar extends React.Component {
    render() {
        return (React.createElement("div", { className: 'col-md-4' },
            React.createElement(WidgetArea_1.default, { name: 'sidebar' })));
    }
}
exports.default = SideBar;
